// extracted by mini-css-extract-plugin
export var container = "_60-0";
export var icon = "_60-1";
export var text = "_60-2";